import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';

interface SearchInputProps {
  searchKey: string;
  onSearch: (searchKey: string) => void;
}

function SearchInput({ onSearch, searchKey }: SearchInputProps) {
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    setSearchText(searchKey);
  }, [searchKey]);

  const handleSearch = () => {
    onSearch(searchText);
  };

  const handleClear = () => {
    setSearchText('');
    onSearch('');
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(event.target.value);
  };

  return (
    <div>
      <TextField
        fullWidth
        variant="outlined"
        size="small"
        label="Search"
        sx={{ width: 200, ml: 1 }}
        value={searchText}
        onChange={handleInputChange}
        onKeyDown={(event) => {
          if (event.key === 'Enter') handleSearch();
        }}
        InputProps={{
          endAdornment: (
            <>
              {searchText && (
                <IconButton onClick={handleClear} edge="end">
                  <ClearIcon />
                </IconButton>
              )}
              <IconButton onClick={handleSearch} edge="end">
                <SearchIcon />
              </IconButton>
            </>
          ),
        }}
      />
    </div>
  );
}

export default SearchInput;
